import { Component, Input } from "@angular/core";
import { Contract } from "@edp-components/edp-contract";
import { IAppState } from "@edp-store/state/app.state";
import { Store, select } from "@ngrx/store";
import { isSingleContract } from "@edp-store/selectors/contract.selectors";
import { ContractService } from "@edp-services/contract.service";
import { EdpModalService } from "@edp-components/edp-modal";
import { EdpContractListComponent } from "@edp-components/edp-contract-list/edp-contract-list.component";

@Component({
    selector: "edp-header-contract-offer",
    templateUrl: "./edp-header-contract-offer.component.html",
    styleUrls: ["./edp-header-contract-offer.component.scss"]
})
export class EdpHeaderContractOfferComponent {

    @Input() set contractSelected(contract: Contract) {
        this.contract = contract;
    }
    public contract: Contract;
    public isSingleContract = true;

    constructor(
        private store: Store<IAppState>,
        private contractService: ContractService,
        private edpModalService: EdpModalService
    ) {
        this.store.pipe(select(isSingleContract)).subscribe((isSingleContract: boolean) => {
            if (!isSingleContract) {
                this.isSingleContract = isSingleContract;
            }
        });
    }

    public showContractList(canClose: boolean) {
        const { options, modal } = this.contractService.getFullModalParam(canClose);
        this.edpModalService.custom(EdpContractListComponent, options, modal).then(() => { /* Intentionally silent */ });
    }
}
